import forEach from 'lodash/forEach';

const { surveyHash, referral, tempAnswerHash } = (() => {
  const pathname = window.location.pathname;
  let usedModule;
  let result;

  const orderedPattern = [
    {
      label: 'tempAnswer',
      pattern: /^\/s\/([^/]+?)\/a\/([^/]+?)(?:\/)?$/i,
    },
    {
      label: 'referral',
      pattern: /^\/s\/([^/]+?)\/f\/([^/]+?)(?:\/)?$/i,
    },
    {
      label: 'none',
      pattern: /^\/s\/([^/]+?)(?:\/)?$/i,
    },
  ];

  forEach(orderedPattern, patternWithLabel => {
    const { label, pattern } = patternWithLabel;
    const pathnameInfo = pattern.exec(pathname);

    if (pathnameInfo) {
      usedModule = label;
      result = pathnameInfo;
      return false;
    }
  });

  return {
    surveyHash: result && result[1] ? result[1] : '',
    tempAnswerHash: usedModule === 'tempAnswer' && result && result[2]
      ? result[2]
      : undefined,
    referral: usedModule === 'referral' && result && result[2]
      ? result[2]
      : undefined,
  };
})();

export { surveyHash, referral, tempAnswerHash };
